<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <list-page
        :columns="columns"
        :headers="headers"
        :show-add-button="false"
        sort="id"
        :descending="true"
        title="Error Logs"
        icon="mdi-lock"
        stateendpoint="errorLog.errorLogs"
        :actions="actions"
        :show-default-action-buttons="false"
    />
  </div>
</template>
<script>
import ListPage from "../components/ListPage";

export default {
  name: 'WPAccess',
  metaInfo: {
    title: 'zetrank.com',
    titleTemplate: 'Admin Dashboard - Error Logs | %s',
    meta: [
      { name: 'robots', content: 'noindex' },
      { name: 'googlebot', content: 'noindex' }
    ]
  },
  components: {ListPage},
  data() {
    return {
      headers: [
        {
          text: 'Logs',
          value: 'logs'
        }
      ],
      columns: [
        {value: 'logs'},
        {value: 'action'}
      ],
      actions: {
        load: 'loadErrorLogs'
      }
    }
  }
}
</script>
